export enum ResetPasswordMfaType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export type RequestMfaCodeResponse = {
  customerId: string;
  mfaDestination: string;
  mfaType: string;
};

export type VerifySecurityQuestionbody = {
  answer: string;
  customData: {
    stateToken: string;
    needToConvert: boolean;
    mfaDestination: string;
  };
  stateToken: string;
};
